export const Footer = ({ t }) => (
  <footer data-testid="footer" className="border-t border-[#F4F0E6]/10 py-14 px-6">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
      <div>
        <div className="flex items-center gap-4">
          <img src="/brand/mark.png" alt="Legend mark" className="h-12 w-auto" />
          <img src="/brand/wordmark.png" alt="Legend" className="h-8 w-auto" />
        </div>
        <p className="font-heading italic text-[#D4A373] mt-3">{t.footer.tagline}</p>
      </div>
      <div className="text-sm text-[#A8A294] md:text-right space-y-1">
        <p>{t.footer.place}</p>
        <p>{t.footer.date}</p>
        <p className="text-xs pt-3 text-[#A8A294]/60">{t.footer.rights}</p>
      </div>
    </div>
  </footer>
);
